import { GeneralService } from './../../services/admin/general.service';
import { EMService } from './../../services/invoices-em/em.service';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { IndicadorImpuestosService } from '../../services/indicador-impuestos/indicador-impuestos.service';
import { Component, OnInit, ViewChild, TemplateRef, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-invoicesem',
  templateUrl: './invoices-em.component.html',
  styleUrls: ['./invoices-em.component.scss'],
  providers: [GeneralService, CatalogsService, EMService, IndicadorImpuestosService]
})
export class EMComponent implements OnInit {

  @Input() entradasMercanciaSeleccionadas;
  @Input() totalOC;
  @Input() cerrarModal;
  @Input() paisDeProveedor;
  @ViewChild('myTable') table: any;
  @ViewChild('detailsTemplate') detailsTemplateRef: TemplateRef<any>;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  proveedores: CatalogsService;
  mostrarBtn = false;
  sociedades;
  ordenCompra;
  orden;
  verDetalle = true;
  entradaMercancia;
  entradas = [];
  rows = [];
  importeTotal = 0;
  claveMoneda = '';
  cantidad = 0;
  objEntradas = [];
  objOrdenesC = [];
  fPaginaField = 1;
  cantidadFacturas = 0;
  objLength = [];
  modalFilters;
  rol;
  btnFiltros;

  orden_compra = {
    idOrdenCompra: 0,
    condPago: '',
    idProveedor: '',
    moneda: '',
    sociedad: 0,
    flag: '',
    importeFactura: '',
    tipoDeImputacion: '',
    totalOc: '',
    indicadorWebre: '',
    centro: '',
    wo_em: '',
    dummy_rfc: '',
    dummy_nombre: ''
  };

  proveedorFilter;
  sociedadFilter;
  ordenCompraFilter;
  sociedadOKFI: boolean = false;

  closeResult: string;
  busy = false;
  busyListado = false;
  busyBusqueda = false;
  busyEM = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  flagBtnCargar = false;
  flagDatos = false;
  flagMDatos = false;
  flagEntradas;
  flagBuscar;
  flagMensaje;
  toastMessage;
  mensajeCargarMas = false;

  deduciblesLista = [];
  conDeducibleLista = [];
  sinDeducibleLista = [];
  indicadorImpuesto;
  indicadorImpuestoSelected = null;
  valueOrdenCompra;
  listaProveedores;
  tipoProveedor;
  paisProveedor;
  pais;

  l: any = 0;
  checkAll: boolean = false;

  public toasterconfig: ToasterConfig = new ToasterConfig({ timeout: 500 });

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    public catalogs: CatalogsService,
    private emService: EMService,
    private indicadoresImpuestosService: IndicadorImpuestosService,
    private modalService: NgbModal,
    private toasterService: ToasterService,

  ) {
    this.obtenerProveedores();

    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastSeleccionarEntradas').subscribe(
      text => {
        this.toastMessage = text;
      });

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    this.pais = this.user.pais;
    this.modulo();
    this.getSociedades();
    this.getIndicadores();

    if (this.rol === 3) {
      this.paisProveedor = this.pais;
      this.flagEntradas = false;
      this.btnFiltros = true;
      if (this.pais == 'MX') {
        this.tipoProveedor = 'E';
      } else {
        this.tipoProveedor = 'EX';
      }
    } else {
      // this.getProveedores();
      this.flagEntradas = true;
      this.btnFiltros = false;
    }
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Con ordenes de compra').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  obtenerProveedores() {
    this.valueOrdenCompra = '';
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(), 
        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  getIndicadores() {
    this.deduciblesLista = [];
    this.conDeducibleLista = [];
    this.sinDeducibleLista = [];

    this.indicadoresImpuestosService.getIndicadoresDeImpuestos().subscribe(
      data => {
       
        if (data.indicadorImpExt.length) {
          // Agregar la propiedad tipoDeducible
          this.deduciblesLista = data.indicadorImpExt.map(item => {
            return {
              ...item,
              tipoDeducible: item.deducible ? this.translate.instant('texto.SiDeducible') : this.translate.instant('texto.NoDeducible')
            };
          });

          // this.conDeducibleLista = data.indicadorImpExt.filter(item => item.deducible === true);
          // this.sinDeducibleLista = data.indicadorImpExt.filter(item => item.deducible === false);
        }

      },
      err => {},
    );
  }

  customSearchFn(term, item) {  
    term = term.toLowerCase();

    return item.indicador.toLowerCase().indexOf(term) > -1 || item.descripcion.toLowerCase().indexOf(term) > -1;
  }
  
  taxSelected(event) {
    this.indicadorImpuestoSelected = event;
  }

  getSociedades() {
    this.busy = true;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;
      },
      err => {
        // console.log(err);
      },
    );
  }

  tProveedor(e) {
    if (this.proveedorFilter == null) {
      this.valueOrdenCompra = '';
      this.sociedadOKFI = false;
      this.indicadorImpuesto = null;
    }

    this.objLength = [];
    this.rows = [];
    this.cantidadFacturas = 0;
    this.importeTotal = 0;

    if (e) {
      if (e.pais == 'MX') {
        this.tipoProveedor = 'E';
      } else {
        this.tipoProveedor = 'EX';
      }
      this.paisProveedor = e.pais;
    }
  }

  selecciones(index, row) {
    let self = this;
    this.objLength = [];

    if (this.entradaMercancia[index].selected) {
      this.entradaMercancia[index].selected = false;
    } else {
      this.entradaMercancia[index].selected = true;
    }

    if (this.entradaMercancia && this.entradaMercancia.length > 0) {
      for (let i = 0; i < this.entradaMercancia.length; i++) {
        if (this.entradaMercancia[i].selected) {
          this.objLength.push(this.entradaMercancia[i]);
        }
      }
    }

    this.cantidadFacturas = this.objLength.length;
  
    this.checkAll = true;
    if (this.objLength.length) {
      this.entradaMercancia.some(function(item) {
        if (!item.selected) {
          self.checkAll =  false;
        } 
      });
    } else {
      this.checkAll = false;
    }
  }

  selectAll(index, checked) {
    this.objLength = [];

    // if (this.entradaMercancia[index].selected) {
      this.entradaMercancia[index].selected = checked;
    // } else {
    //   this.entradaMercancia[index].selected = true;
    // }

    if (this.entradaMercancia && this.entradaMercancia.length > 0) {
      for (let i = 0; i < this.entradaMercancia.length; i++) {
        if (this.entradaMercancia[i].selected) {
          this.objLength.push(this.entradaMercancia[i]);
        }
      }
    }

    this.cantidadFacturas = this.objLength.length;
  }

  onSelect(e: any) {
    const checked = e.target.checked;
    this.rows.forEach((item: any) => {
      this.selectAll(item.indexEntradaTmp, checked)
    });
  }

  getOrdenesCompra() {
    this.verDetalle = false;
    this.mensajeCargarMas = false;
    this.flagBtnCargar = false;
    const rol = this.user.rol.id;
    this.objLength = [];
    this.cantidadFacturas = 0;
    const iPagina = 1;
    let userProveedorId;

    if (rol === 3) {
      this.busy = true;
      userProveedorId = this.user.id;
    } else {
      this.busyListado = true;
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
        this.flagEntradas = false;
      } else if (this.proveedorFilter === '' || this.proveedorFilter === null || this.proveedorFilter === undefined) {
        this.btnFiltros = false;
      }
    }

    this.emService.obtenerOrdenesCompra(userProveedorId, iPagina).subscribe(
      data => {
        this.busy = false;
        this.busyListado = false;
        this.ordenCompra = data.ordenCompra;

        if (this.ordenCompra.length > 0) {
          this.btnFiltros = true;
          this.flagBtnCargar = true;
        } else {
          this.btnFiltros = false;
        }

        if (this.ordenCompra.length > 7) {
          this.mostrarBtn = true;
        } else {
          this.mostrarBtn = false;
        }

        if (this.ordenCompra.length === 0) {
          this.flagDatos = true;
        } else {
          this.flagDatos = false;
        }

      },
      err => {

        // console.log(err);

      },
    );

  }

  reload() {
    this.mensajeCargarMas = false;
    this.busyListado = true;
    this.rows = [];
    this.verDetalle = false;
    this.importeTotal = 0;
    this.claveMoneda = '';
    this.ordenCompra = '';
    const rol = this.user.rol.id;
    let userProveedorId;

    if (rol === 3) {
      userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      } else if (this.proveedorFilter === '' || this.proveedorFilter === null || this.proveedorFilter === undefined) {
        this.btnFiltros = false;
      }
    }

    this.emService.obtenerOrdenesCompra(userProveedorId, 1).subscribe(
      data => {

        this.ordenCompra = data.ordenCompra;

        if (this.ordenCompra.length > 0) {
          this.btnFiltros = true;
          this.flagBtnCargar = true;
        } else {
          this.btnFiltros = false;
        }

        if (this.ordenCompra.length > 7) {
          this.mostrarBtn = true;
        } else {
          this.mostrarBtn = false;
        }

        if (this.ordenCompra.length === 0) {
          this.flagDatos = true; 
        } else {
          this.flagDatos = false; 
        }

        this.busyListado = false;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  index;
  getEntradasMercancia() {
    this.busyEM = true;
    this.verDetalle = true;
    this.importeTotal = 0;
    let total;
    this.cantidad = 0;
    this.entradas = [];
    this.orden = this.valueOrdenCompra;
    const rol = this.user.rol.id;
    let userProveedorId;
    this.objLength = [];
    this.rows = [];
    this.cantidadFacturas = this.objLength.length;
    this.sociedadOKFI = false;
    this.indicadorImpuesto = null;

    if (rol === 3) {
      userProveedorId = this.user.id;
    } else {
      userProveedorId = this.proveedorFilter;
    }

    this.emService.obtenerEntradasMercancia(this.orden, userProveedorId, this.tipoProveedor).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      data => {
        this.busyEM = false;
        if (data) {

          if (data.results.length > 0) {

            data.results.forEach((item:any, index:any) => { 
              item.indexEntradaTmp = index;
            });

            this.entradaMercancia = data.results; 
            this.rows = this.entradaMercancia; 
           
            this.sociedadOKFI = (this.rows[0].sociedad === 'OKFI') ? true : false;

            for (let i = 0; i < this.rows.length; i++) {
              total = parseFloat(this.rows[i].importe);
              this.importeTotal += total;
            }

          } 
          // else {
          //   this.toasterService.pop('error', 'ERROR', data.mensaje);
          // }
        }

      },
      err => {
        this.busyEM = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }


  open(content) { 

    if (this.objLength.length > 0) {
      const modalRef = this.modalService.open(UploadModalComponent, { size: 'lg', keyboard: false, backdrop: 'static' });
      modalRef.componentInstance.entradasMercanciaSeleccionadas = this.objLength;
      modalRef.componentInstance.totalOC = this.importeTotal;
      if (this.sociedadOKFI) modalRef.componentInstance.sociedadOKFI = this.indicadorImpuestoSelected;
      modalRef.componentInstance.paisDeProveedor = this.paisProveedor;
      if (this.rol === 2) modalRef.componentInstance.proveedor = this.proveedorFilter;
      
      //   modalRef.componentInstance.cerrarModal = modalRef.close();
      modalRef.result.then((result) => {
        if (result === 'cancelar') {
          // console.log('cancelo envio');
        } else {
          this.objLength = [];
          this.cantidadFacturas = 0;
          this.verDetalle = false;
          this.rows = [];
          this.valueOrdenCompra = null;
          this.sociedadOKFI = false;
          this.indicadorImpuesto = null;
          modalRef.close();
        }
      }).catch((error) => {
        // console.log(error);
      });
    } else {
      this.toasterService.pop('error', 'ERROR', this.toastMessage);
    }

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilters(filtersOC) {
    this.flagBuscar = false;
    this.modalFilters = this.modalService.open(filtersOC, { centered: true });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  buscar() {
    this.busyBusqueda = true;
    let sociedad = this.sociedadFilter;
    let ordenCompraOpc = this.ordenCompraFilter;
    const rol = this.user.rol.id;
    let proveedor;

    if (rol === 3) {
      proveedor = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        proveedor = this.proveedorFilter;
      }
    }

    if (proveedor === undefined || proveedor === null) {
      proveedor = '';
    }
    if (sociedad === undefined || sociedad === null) {
      sociedad = '';
    }
    if (ordenCompraOpc === undefined || ordenCompraOpc === null) {
      ordenCompraOpc = '';
    }

    if ((sociedad === '') && (ordenCompraOpc === '')) {
      this.flagBuscar = false;
      this.flagMensaje = true;
    } else {
      this.flagBuscar = true;
      this.flagMensaje = false;
    }

    if (this.flagBuscar === true) {
      this.emService.busquedaOrdenesCompra(proveedor, ordenCompraOpc, sociedad).subscribe(
        data => {
          this.busyBusqueda = false;
          this.ordenCompra = data;
          this.ordenCompra = this.ordenCompra.ordenCompra;
          this.modalFilters.close();

          if (this.ordenCompra.length === 0) {
            this.flagDatos = true; 
            this.flagEntradas = false;
          } else {
            this.flagDatos = false; 
          }

        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );
    } else {
      this.busyBusqueda = false;
    }

  }

  cargarMas() {
    this.mostrarBtn = false;
    this.busyListado = true;
    const rol = this.user.rol.id;
    let item = 0; let count = 0;
    // Incrementa una Página mas
    let iPagina = this.fPaginaField;
    iPagina++;
    this.fPaginaField = iPagina;
    // Toma el Id del Usuario Proveedor
    let userProveedorId;

    if (rol === 3) {
     userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      }
    }

    this.emService.buscarOrdenesCompra(userProveedorId, iPagina).subscribe(
      data => {
        this.busyListado = false;
        const response = data.ordenCompra;
        if (response.length > 0) {
          // this.ordenCompra = data.ordenCompra;
          this.mensajeCargarMas = false;
          for (let i = 0; i < response.length; i++) {
            item = this.ordenCompra;
            count = count + item;
          }
          this.ordenCompra = count; 

        } else {
          this.mensajeCargarMas = true;
          this.mostrarBtn = false;
        }
      },
      err => {
        this.busyListado = false;
        if (err.status === 401) {
          this.storageService.openLogout() ;
        } 
      },
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/invoices-em/invoices-em.component.ts